import type { ReactNode } from 'react';
import { Icon } from './Icon';

/** DESIGN.md §7 copy rule: state what happened, which thing, what to do — never "Oops". */
export function ErrorState({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="state-panel state-panel--error" role="alert" data-testid="error-state">
      <div className="state-panel__icon">
        <Icon name="alert" size={32} />
      </div>
      <p className="state-panel__title text-subtitle">{title}</p>
      {description && <p className="state-panel__description text-body">{description}</p>}
      {action}
    </div>
  );
}
